export default {
  'en-US': {
    packagingType: {
      // Parcel: 'Parcel (standard shipping)',
      // PalletizedContainerOrLTL: 'Palletized container or LTL (less-than-truckload)',
      // FloorLoadedContainer: 'Floor loaded container'
      Parcel: {
        Name: 'Parcel (standard shipping)',
        Text: ''
      },
      PalletizedContainerOrLTL: {
        Name: 'Palletized container or LTL (less-than-truckload)',
        Text: ''
      },
      FloorLoadedContainer: {
        Name: 'Floor loaded container',
        Text: 'We require 1 WRO per container.'
      }
    },
    skuType: {
      OneSKUPerContainer: {
        Name: 'One SKU per {container}',
        Text: 'Each {container} contains a single SKU'
      },
      MultipleSKUPerContainer: {
        Name: 'Multiple SKUs per {container}',
        Text: 'Each {container} has 2 or more SKUs'
      }
    },
    labelPurchasingType: {
      PurchaseLabels: {
        Name: 'Discounted printable shipping labels from us (origin US only)',
        Text: 'We will provide you a price estimate once you\'ve entered your shipment details.\n' +
        'You\'ll have the option to opt out prior to purchasing our labels.'
      },
      UseOwnLabels: {
        Name: 'I\'ll use my own labels',
        Text: 'When using your own labels, you must provide tracking numbers.'
      }
    }
  },
  'ja-JP': {
    packagingType: {
      Name: {
        Parcel: 'Parcel (standard shipping)',
        PalletizedContainerOrLTL: 'Palletized container or LTL (less-than-truckload)',
        FloorLoadedContainer: 'Floor loaded container'
      },
      Text: {
        Parcel: '',
        PalletizedContainerOrLTL: '',
        FloorLoadedContainer: 'We require 1 WRO per container.'
      }
    },
    skuType: {
      OneSKUPerContainer: {
        Name: 'One SKU per {container}',
        Text: 'Each {container} contains a single SKU'
      },
      MultipleSKUPerContainer: {
        Name: 'Multiple SKUs per {container}',
        Text: 'Each {container} has 2 or more SKUs'
      }
    },
    labelPurchasingType: {
      PurchaseLabels: {
        Name: 'Purchase printable labels from us (origin US only)',
        Text: 'We\'ll use our discounts to buy labels for you to easily print.'
      },
      UseOwnLabels: {
        Name: 'I\'ll use my own labels',
        Text: ''
      }
    }
  }
}

